// extracted by mini-css-extract-plugin
module.exports = {"CMSPage":"CMSPage_CMSPage__1-ILq","ErrorMsg":"CMSPage_ErrorMsg__3Z5Re","SuccessMsg":"CMSPage_SuccessMsg__3xU2t","ActionButtonsHolder":"CMSPage_ActionButtonsHolder__3zM8E"};